import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <Fragment>
      <footer className="footer2 footer--light">
        <div className="footer__big">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="widget text_widget">
                  <a href="/">
                    <img
                      className="footer_logo"
                      src="img/logo.png"
                      alt="logo"
                    />
                  </a>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-lg-center">
                <div className="widget widget--links">
                  <h4 className="widget__title">quick links</h4>
                  <ul className="links">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <a href="/#about">About</a>
                    </li>
                    <li>
                      <a href="/#productappl">Product Applications</a>
                    </li>
                    <li>
                      <NavLink to="/products">Our Products</NavLink>
                    </li>
                    <li>
                      <a href="Vijaynagar_Biotech.pdf" download>
                        Download Brochure
                      </a>
                    </li>
                    <li>
                      <NavLink to="/contact">Contact</NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__small text-center">
          <p>©2022 Vijay Nagar Biotech. All rights reserved.</p>
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;
